
export enum RoutePathBookingFormEnum {
    PrefixedRoot = "/b",
    Auth_Customer_Login = "/auth/customer/login",
    Auth_Customer_Logout = "/auth/customer/logout",
    Step_Service = "/b/{companySlug}",
    Step_CompanyUser = "/b/{companySlug}/{serviceSlug}",
    Step_Date = "/b/{companySlug}/{serviceSlug}/dates",
    Step_Date_AvailableDates = "/b/{companySlug}/{serviceSlug}/available-dates",
    Step_Confirmation = "/b/{companySlug}/{serviceSlug}/confirm",
    Step_Confirmation_Stripe = "/b/{companySlug}/{serviceSlug}/confirm/stripe",
    Step_Confirmation_PayPal = "/b/{companySlug}/{serviceSlug}/confirm/paypal",
    Step_Confirmation_PayPal_CreateOrder = "/b/{companySlug}/{serviceSlug}/confirm/paypal/order",
    Step_Success = "/b/{companySlug}/{serviceSlug}/success",
    Legacy_Step_Service = "/{companySlug}",
    Legacy_Step_CompanyUser = "/{companySlug}/{serviceSlug}",
    Legacy_Step_Date = "/{companySlug}/{serviceSlug}/dates",
    Legacy_Step_Date_AvailableDates = "/{companySlug}/{serviceSlug}/available-dates",
    Legacy_Step_Confirmation = "/{companySlug}/{serviceSlug}/confirm",
    Legacy_Step_Success = "/{companySlug}/{serviceSlug}/success",
}

export enum RoutePathFreeToolEnum {
    Root = "/free-tools",
    BusinessNameGenerator_StepStart = "/free-tools/business-name-generator",
    BusinessNameGenerator_StepResults = "/free-tools/business-name-generator/results",
    BusinessNameGenerator_StepResultPreview = "/free-tools/business-name-generator/results/{businessNameSuggestionId}/preview",
    BusinessNameGenerator_StepRegister = "/free-tools/business-name-generator/register",
    BusinessNameGenerator_StepRegister_GoogleRedirect = "/free-tools/business-name-generator/register/google",
    BusinessNameGenerator_StepRegister_GoogleCallback = "/free-tools/business-name-generator/register/google/callback",
    BusinessNameGenerator_StepRegister_MicrosoftRedirect = "/free-tools/business-name-generator/register/microsoft",
    BusinessNameGenerator_StepRegister_MicrosoftCallback = "/free-tools/business-name-generator/register/microsoft/callback",
    BusinessNameGenerator_StepSuccess = "/free-tools/business-name-generator/success",
}

export enum RoutePathMarketingEnum {
    Root = "/",
    Empty = "",
    PrivacyPolicy = "/privacy-policy",
    TermsOfService = "/terms-of-service",
    RefundPolicy = "/refund-policy",
    Support = "/support",
    ZoomTutorial = "/zoom-tutorial",
    Feature_FlexibleAvailability = "/features/flexible-availability",
    Feature_GroupMeetings = "/features/group-meetings",
    Feature_RecurringMeetings = "/features/recurring-meetings",
    Feature_SmsWhatsAppReminders = "/features/sms-whatsapp-reminders",
    Feature_Automations = "/features/automations",
    Feature_Integrations = "/features/integrations",
    Feature_Payments = "/features/payments",
    Feature_FlexibleMeetingLocations = "/features/flexible-meeting-locations",
    Feature_FlexibleScheduling = "/features/flexible-scheduling",
    Sitemap_Marketing = "/sitemaps/marketing.xml",
    Sitemap_Blog = "/sitemaps/blog.xml",
    Sitemap_HelpCenter = "/sitemaps/help-center.xml",
}

export enum RoutePathCookieConsentEnum {
    Upsert = "/consent",
}

export enum RoutePathWebhookEnum {
    Stripe_Connect = "/stripe/connect",
    Paddle = "/paddle",
    Zoom_Deauthorize = "/zoom/deauthorize",
    Paypal_MultiParty = "/paypal/multiparty",
}

export enum RoutePathMeetingEnum {
    View = "/view",
    Meetings_Dates = "/meetings/dates",
    Meetings_Reschedule = "/meetings/reschedule",
    Meetings_Cancel = "/meetings/cancel",
    Meetings_Recurring_Cancel = "/meetings/recurring/cancel",
}

export enum RoutePathAppEnum {
    Root = "/",
    Auth_Login = "/auth/login",
    Auth_Logout = "/auth/logout",
    Auth_Register = "/auth/register",
    Auth_ForgotMyPassword = "/auth/forgot-my-password",
    Auth_CreateNewPassword = "/auth/create-new-password",
    Auth_User_Social_Google_Redirect = "/auth/social/google/redirect",
    Auth_User_Social_Google_Callback_Login = "/auth/social/google/callback/login",
    Auth_User_Social_Google_Callback_Register = "/auth/social/google/callback/register",
    Auth_User_Social_Microsoft_Redirect = "/auth/social/microsoft/redirect",
    Auth_User_Social_Microsoft_Callback_Login = "/auth/social/microsoft/callback/login",
    Auth_User_Social_Microsoft_Callback_Register = "/auth/social/microsoft/callback/register",
    Auth_Login_Companies = "/auth/login/companies",
    Auth_EmailVerification = "/auth/email-verification",
    Auth_VerifyEmail = "/auth/verify-email",
    Auth_EmailVerification_Resend = "/auth/email-verification/resend",
    Onboarding = "/onboarding",
    Onboarding_Step1_Welcome = "/onboarding/welcome",
    Onboarding_Step2_BookingReason = "/onboarding/booking-reason",
    Onboarding_Step3_BookingPage = "/onboarding/booking-page",
    Onboarding_Step4_Availability = "/onboarding/availability",
    Onboarding_Step4_Availability_PreDefined = "/onboarding/availability/predefined",
    Onboarding_Step4_Availability_Custom = "/onboarding/availability/custom",
    Onboarding_Step5_Integrations = "/onboarding/integrations",
    Onboarding_Step6_BusinessInfo = "/onboarding/business-info",
    Onboarding_Step7_Finished = "/onboarding/finished",
    Billing = "/billing",
    Billing_Plans_Index = "/billing/plans",
    Billing_Plans_Change = "/billing/plans/change",
    Billing_Paddle_Checkout = "/billing/paddle/checkout",
    Billing_Paddle_CustomerPortal = "/billing/paddle/customer-portal",
    Billing_Paddle_ChangePlan = "/billing/paddle/change-plan",
    MyProfile = "/my-profile",
    MyProfile_Update = "/my-profile/update",
    MyProfile_UpdatePassword = "/my-profile/update-password",
    MyProfile_Services_Associate = "/my-profile/services/associate",
    Company = "/company",
    Company_Update_Info = "/company/update/info",
    Company_Update_BookingFormTheme = "/company/update/booking-form-theme",
    Company_Update_DefaultAvailability = "/company/update/default-availability",
    Company_Update_EmbedButtonSettings = "/company/update/embed-button-settings",
    Company_Delete = "/company/delete",
    Company_MeetingLocations_Store = "/company/meeting-locations/store",
    Company_MeetingLocations_Delete = "/company/meeting-locations/delete",
    Integrations = "/integrations",
    Integrations_Delete = "/integrations/delete",
    Integrations_GoogleCalendar_Redirect = "/integrations/google-calendar/redirect",
    Integrations_GoogleCalendar_Callback = "/integrations/google-calendar/callback",
    Integrations_GoogleCalendar_Update_Settings = "/integrations/google-calendar/update/settings",
    Integrations_OutlookCalendar_Redirect = "/integrations/outlook-calendar/redirect",
    Integrations_OutlookCalendar_Callback = "/integrations/outlook-calendar/callback",
    Integrations_OutlookCalendar_Update_Settings = "/integrations/outlook-calendar/update/settings",
    Integrations_GoogleMeet_Redirect = "/integrations/google-meet/redirect",
    Integrations_GoogleMeet_Callback = "/integrations/google-meet/callback",
    Integrations_Zoom_Redirect = "/integrations/zoom/redirect",
    Integrations_Zoom_Callback = "/integrations/zoom/callback",
    Integrations_StripeConnect_Redirect = "/integrations/stripe-connect/redirect",
    Integrations_PayPalMultiParty_Redirect = "/integrations/paypal-multiparty/redirect",
    AnalyticsEvents_Store = "/analytics",
    CompanyUsers_Edit = "/company/users/edit",
    CompanyUsers_Update = "/company/users/update",
    CompanyUsers_Delete = "/company/users/delete",
    CompanyUsers_Invites_Delete = "/company/invites/delete",
    CompanyUsers_Invites_Send = "/company/invites/send",
    CompanyUsers_Invites_Accept = "/company/invites/accept",
    CompanyUsers_Services_Associate = "/company-users/services/associate",
    CompanyUsers_Availability_Associate = "/company-users/availability/associate",
    Admin_Queue_Pending = "/admin/queue/pending",
    Admin_Queue_Pending_Stats = "/admin/queue/pending/stats",
    Admin_Queue_Processed = "/admin/queue/processed",
    Admin_Queue_Retry = "/admin/queue/retry",
    Admin_Users = "/admin/users",
    Admin_Users_EnterImpersonateMode = "/admin/users/enter-impersonate-mode",
    Admin_Users_LeaveImpersonateMode = "/admin/users/leave-impersonate-mode",
    Admin_Posts_Images = "/admin/posts/images",
    Admin_Posts = "/admin/posts",
    Admin_Posts_Create = "/admin/posts/create",
    Admin_Posts_Edit = "/admin/posts/edit",
    Admin_Posts_Update = "/admin/posts/update",
    Admin_Posts_Publish = "/admin/posts/publish",
    Admin_Posts_Unpublish = "/admin/posts/unpublish",
    Availabilities = "/availabilities",
    Availabilities_Edit = "/availabilities/edit",
    Availabilities_Store = "/availabilities/store",
    Availabilities_Update_Details = "/availabilities/update/details",
    Availabilities_Update_WeeklyHours = "/availabilities/update/weekly-hours",
    Availabilities_Update_DateSpecificHours = "/availabilities/update/date-specific-hours",
    Availabilities_Update_Ai = "/availabilities/update/ai",
    Availabilities_Delete = "/availabilities/delete",
    Legacy_Orders_View = "/orders/view",
    Meetings = "/meetings",
    Meetings_Attendee_ToggleNoShow = "/meetings/attendees/toggle-no-show",
    Meetings_Payment_Refund_NonRecurring = "/meetings/payment/refund/non-recurring",
    Meetings_Payment_Refund_Recurring = "/meetings/payment/refund/recurring",
    Recurring = "/recurring",
    Services = "/services",
    Services_Edit = "/services/edit",
    Services_Delete = "/services/delete",
    Services_Update_GeneralSettings = "/services/update/general-settings",
    Services_Update_SchedulingSettings = "/services/update/scheduling-settings",
    Services_Update_PaymentSettings = "/services/update/payment-settings",
    Services_Update_RecurrenceSettings = "/services/update/recurrence-settings",
    Services_Update_GroupSchedulingSettings = "/services/update/group-scheduling-settings",
    Services_CompanyUsers = "/services/company-users",
    Services_CompanyUsers_Associate = "/services/company-users/associate",
    Services_Prices_Store = "/services/prices/store",
    Services_Prices_Update = "/services/prices/update",
    Services_Prices_Delete = "/services/prices/delete",
    Services_CustomFields_Store = "/services/custom-fields/store",
    Services_CustomFields_Update = "/services/custom-fields/update",
    Services_CustomFields_Delete = "/services/custom-fields/delete",
    Services_CustomFields_MoveUp = "/services/custom-fields/move-up",
    Services_CustomFields_MoveDown = "/services/custom-fields/move-down",
    Services_Availability_Associate = "/services/availability/associate",
    Customers = "/customers",
    Automations = "/automations",
    Automations_Edit = "/automations/edit",
    Automations_Store = "/automations/store",
    Automations_Delete = "/automations/delete",
    Automations_Update_GeneralSettings = "/automations/update/general-settings",
    Automations_Update_State = "/automations/update/state",
    Automations_Update_Action = "/automations/update/action",
    Automations_Update_Trigger = "/automations/update/trigger",
}

export enum RoutePathBlogEnum {
    Home_Show = "/blog",
    Category_Show = "/blog/category/{categorySlug}",
    Article_Show = "/blog/{articleSlug}",
}

export enum RoutePathCustomerEnum {
    Root = "/",
    Auth_Login = "/auth/login",
    Auth_Logout = "/auth/logout",
    Auth_PasswordReset = "/auth/password-reset",
    Auth_CreateNewPassword = "/auth/create-new-password",
    Auth_Customer_Social_Google_Redirect = "/auth/social/google/redirect",
    Auth_Customer_Social_Google_Callback = "/auth/social/google/callback",
    Meetings = "/meetings",
    Meetings_View = "/meetings/view",
}

export enum RoutePathHelpCenterEnum {
    Home_Show = "/help",
    Articles_Index = "/help/categories/{categorySlug}",
    Articles_Show = "/help/articles/{articleSlug}",
}
